import React, { Component } from 'react';

import { GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

import BlockedPopUp from './BlockedPopUp.jsx';

let userInfoForm = undefined;
let simultaneousAccessByPlataformForm = undefined;

class SaveCancelButton extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        userInfoForm = $("#user-info-form");
        simultaneousAccessByPlataformForm = $("#simultaneous-access-by-plataform");
    }

    onSaveUserClick() {
        if (userInfoForm.valid() && simultaneousAccessByPlataformForm.valid()) {
            if (this.props.selectedUserId != null && this.props.selectedUserId > 0) {
                this.props.editUsuario();
            }
            else {
                this.props.createUsuario();
            }
        }
    }

    onModalConfirmClick() {
        $("#cancel-modal").modal("hide");
        this.props.cancelClick();
    }

    onCancelUserClick() {
        if (this.props.usuarioConCambios == true) {
            $("#cancel-modal").modal({ backdrop: "static" });
        } else {
            this.props.cancelClick();
        }
    }

    render() {
        let saveButton = <GenericSimpleButton text="Guardar" buttonClass="btn btn-cta" onClick={() => this.onSaveUserClick()} />
        let CancelButton = <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={() => this.onCancelUserClick()} />

        let blockPlaceComponent = null;

        if (this.props.informacionUsuario != undefined) {
            if (this.props.informacionUsuario != undefined) {
                let estadoActual = this.props.estadoActual;

                if (estadoActual == 'BLOQUEADO') {
                    blockPlaceComponent = <BlockedPopUp data={this.props.data} />;
                }
            }
        }

        return (
            <div className="row bottom-separator-xs">
                <div className="col-md-2">
                    {saveButton}
                </div>
                <div className="col-md-2">
                    {CancelButton}
                </div>
                <div className="col-md-2">
                    {blockPlaceComponent}
                </div>

                <GenericModal id="cancel-modal"
                    className="modal fade-out modal-center"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2 className="modal-title">Descartar Cambios</h2>}
                    footer={<div className="row">
                        <div className="col-xs-5">
                            <button type="button" className="btn btn-cta" onClick={() => this.onModalConfirmClick()}>Descartar Cambios</button>
                        </div>
                        <div className="col-xs-7">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        </div>
                    </div>}
                    body={<p>Se han realizado modificaciones sobre el usuario,
                        en caso de no guardalos se perderán ¿Desea descartar los cambios?</p>}
                />
            </div>
        );
    }
}

export default SaveCancelButton;